













































import {Component, Mixins, Prop } from 'vue-property-decorator';
import _ from 'lodash';

import FactMixin from './FactMixin.vue';
import FactTooltip from './FactTooltip.vue';

@Component({
  name: 'FactUpload',
  components: {
    FactTooltip
  }
})
export default class FactUpload extends Mixins(FactMixin) {
  @Prop() private buttonText!: string;
  private isSelecting: boolean = false;
  private selectedFiles: any[] = [];
  private fileNames: any = [];
  private maxAllowedError: any = '';
  private readonly MAX_FILES: number = 5;

  get label() {
    return (!this.separateHeader && this.description) || '';
  }

  private removeSelectedFile(name: string) {
    const uid = this.getUID();
    this.fileNames = this.fileNames.filter((file: any) => file !== name);
    const selectedFile = this.selectedFiles.find((file: any) => file.name === name);
    this.updateModelAndValidate({selectedFile: selectedFile ? selectedFile : name, fileNames: this.fileNames, remove: true , id: this.factData.id}, true);
    this.selectedFiles = this.selectedFiles.filter((file: any) => file.name !== name);

    // Keep the file input's FileList in sync with the remaining selected files
    this.syncFileInput();

    const allowedExtesions = this.factData.formatOptions[0].value.split(',').map((ext: string) => ext.trim().toLowerCase());
    const invalidFiles = this.fileNames.filter((fileName: any) => {
      const fileNameExt = fileName.split('.').pop();
      if (fileNameExt && allowedExtesions.includes(fileNameExt.toLowerCase())) {
        return false;
      }
      return true;
    });

    if (!invalidFiles.length) {
      (this as any).$resetFactErrors(uid);
    }

    if (this.factData.mandatory && this.fileNames.length === 0) {
      (this as any).$addError(uid, this.$t('validations.shift.REQUIRED_FIELD'));
    }
  }

  private onFileChanged(e) {
    const files = Array.from(e.target.files);
    if (this.selectedFiles.length + files.length > this.MAX_FILES) {
      this.maxAllowedError =  this.$t('validations.exceed_allowed_files', { value: this.MAX_FILES });
      this.syncFileInput();
      return;
    }
    this.maxAllowedError =  '';
    this.selectedFiles = [...this.selectedFiles, ...files];
    if (this.selectedFiles.length > 0) {
      const updatedFileNames = [...this.fileNames, ...this.selectedFiles.map((file: any) => file.name)];
      this.fileNames = [...new Set(updatedFileNames)];
      // Merge previously selected files into the input so v-validate validates all of them
      this.syncFileInput();
      this.updateModelAndValidate({selectedFiles: files, fileNames: this.fileNames, id: this.factData.id}, true);
    }
  }

  private syncFileInput() {
    const fileInput = this.$refs.uploader as HTMLInputElement;
    if (!fileInput || typeof DataTransfer === 'undefined') {
      return;
    }
    const dataTransfer = new DataTransfer();
    this.selectedFiles
      .filter((file: any) => file instanceof File)
      .forEach((file: File) => dataTransfer.items.add(file));
    fileInput.files = dataTransfer.files;
  }

  private onChange(e: Event) {
    const value = _.get(e, 'target.value', '');
    this.updateModelAndValidate(value.trim());
  }

  private handleFileImport() {
    (this.$refs.uploader as any)?.click();
  }

  private autoFill(e: Event) {
    this.updateModelAndValidate(this.modelValue.trim(), true, true);
  }

  private mounted() {
    if (this.factData?.currentValue) {
      this.fileNames = this.factData.currentValue.split(',').map((name: string) => name.trim());
    }
    this.onChange = _.debounce(this.onChange, this.FACT_CHANGE_DEBOUNCE_TIME_OUT);
  }
}
